import React from 'react';
import { Link } from "react-router-dom";
import Table from '../Components/Table/Table';
import { Badge } from "reactstrap";
import { STATUS_COLORS, NAME_PROJECT_XLSX } from '../config/serviceDeskConfigs';


const ItemsToFilter = ['TicketNumber', 'UserProject', 'Subjet', 'Status', 'TypeTicket', 'UpdateDate', 'CreateDate'];


const HeadersEn = {
  keys: ['TicketNumber', 'UserProject', 'Subjet', 'Status', 'TypeTicket', 'createdate', 'updatedate'],
  headers: ['Ticket No', 'Created By', 'Subject', 'Status', 'Type', 'Creation Date', 'Last Update'],
}
const HeadersEs = {
  keys: ['TicketNumber', 'UserProject', 'Subjet', 'Status', 'TypeTicket', 'createdate', 'updatedate'],
  headers: ['Número de Ticket', 'Creado Por', 'Título', 'Estatus', 'Tipo', 'Fecha de Creación', 'Fecha de Actualización'],
}


const dataTikets = [
  { TicketNumber: '20-0000001', CreatedBy: 'Omar Guillen', Subjet: 'Detalle en el Dashboard', Status: 'Open', Type: 'Error', CreationDate: '26-08-2020', LastUpdate: '26-08-2020' }
];

function OpenTickets({ tickets, language, idProject, styleProject }) {
  const columnsEnglish = [
    { key: 'TicketNumber', label: 'Ticket No', custom: (value) => <Link to={'/ticket-detail/' + value.TicketId} className={styleProject ? (styleProject.links ? styleProject.links : '') : ''}> {value.TicketNumber}</Link > },
    { key: 'UserProject', label: 'Created By' },
    { key: 'Subjet', label: 'Subject' },
    { key: 'Status', label: 'Status', custom: (value) => <Badge style={{ width: '100%', background: STATUS_COLORS[idProject], padding: '0.3em' }} pill>{value.Status}</Badge> },
    { key: 'TypeTicket', label: 'Type' },
    { key: 'createdate', label: 'Creation Date' },
    { key: 'updatedate', label: 'Last Update' },
  ];

  const columnsEspanish = [
    { key: 'TicketNumber', label: 'Número de Ticket', custom: (value) => <Link to={'/ticket-detail/' + value.TicketId} className={styleProject ? (styleProject.links ? styleProject.links : '') : ''}>{value.TicketNumber}</Link> },
    { key: 'UserProject', label: 'Creado Por' },
    { key: 'Subjet', label: 'Título' },
    { key: 'Status', label: 'Estatus', custom: (value) => <Badge style={{ width: '100%', background: STATUS_COLORS[idProject], padding: '0.3em' }} pill>{value.Status}</Badge> },
    { key: 'TypeTicket', label: 'Tipo' },
    { key: 'createdate', label: 'Fecha de Creación' },
    { key: 'updatedate', label: 'Fecha de Actualización' },
  ];

  return (
    <>
      <Table
        columns={language === 'Español' ? columnsEspanish : columnsEnglish}
        headers={language === 'Español' ? HeadersEs : HeadersEn}
        nameProject={NAME_PROJECT_XLSX[idProject]}
        data={tickets ? tickets : dataTikets}
        configSearch={{ fieldsToFilter: ItemsToFilter }}
        itemsPerPage={10}
        class={styleProject}
        options={
          {
            pagination: true,
            search: true,
            selectItems: false,
            xlsx: true,
            project: idProject
          }
        }
      />
    </>
  );
}

export default OpenTickets;